import { Address } from "app/shared/models/address.model";
import { BankAccount } from "app/shared/models/bank-account.model";

/**
 * Model for Bank Institutions.
 */
export class BankInstitution {
    bankId: number;
    bankName: string;
    bankCode: string;
    bankAddress: Address;
    bankAccounts: BankAccount[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/bank-institution.model.ts